import language from "../../language";
import toastMessage from "../toastMessage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchDiagnosisOptions = async (lng = "english", params = {}) => {
  try {
    if (!params.q) {
      delete params.q;
    }

    const options = {
      method: "GET",
      url: `${API_URL}/diagnosisOption`,
      params,
    };

    const queryRes = await api(options);
    let { data, count, totalRecords } = queryRes.data;

    if (params.inputType === "dropdown") {
      return (queryRes?.data?.data || queryRes?.data || []).map((el) => ({
        ...el,
        label: el.label,
        value: el.value,
      }));
    }

    return !params.page && !params.limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
    return params.inputType === "dropdown" ? [] : { data: [], count: 0 };
  }
};

export const addDiagnosisOption = async (data) => {
  try {
    const method = data.id ? "PUT" : "POST";
    const options = {
      method,
      url: `${API_URL}/diagnosisOption`,
      data,
    };

    const queryRes = await api(options);
    return queryRes.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteDiagnosisOption = async (lng = "english", id) => {
  try {
    const options = {
      method: "DELETE",
      url: `${API_URL}/diagnosisOption`,
      data: { id },
    };

    await api(options);
    toastMessage("success", language[lng].delete_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};
